module.exports = __webpack_public_path__ + "stu-res/img/getin.d0ffa0a4.png";